import {Link, Outlet} from "react-router-dom";
import { useEffect } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useTranslation } from 'react-i18next';
import SiteFonts from "../components/SiteFonts";
export default function Layout() {
const { t, i18n } = useTranslation();
useEffect(() => {
    // Set dir attribute on document.body based on language
    document.body.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    
    // Clean up when component unmounts
    return () => {
        document.body.dir = 'ltr';
};

}, [i18n.language]); // Re-run effect when language changes
    return <>
        <SiteFonts />
        <Header/>
            <main className={`main ${i18n.language === 'ar' ? 'rtl' : 'ltr'}`}>
                <Outlet/>
            </main>
        <Footer/>
    </>
  }